import { PauseCover, useUnsavedChanges } from "aic";
import { NavLink, NavLinkProps, useLocation } from "react-router-dom";

/**
 * Navigation link component that handles unsaved changes and displays loading state.
 *
 * @param props - Navigation link properties including destination and styling
 */
export const ActiveNavLink = (props: NavLinkProps): React.ReactElement => {
  const { navigate, isLoading } = useUnsavedChanges(props.to.toString());
  const location = useLocation();

  return (
    <div className="position-relative overflow-hidden">
      {isLoading === props.to.toString() && <PauseCover />}
      <NavLink
        {...props}
        style={({ isActive }) =>
          isActive ? { color: "black", textDecorationLine: "none", cursor: "default" } : {}
        }
        to={props.to}
        end={true}
        onClick={(e) => {
          if (e.ctrlKey || e.metaKey || e.button === 1 || e.shiftKey) {
            return; // Allow default behavior for these keys
          }
          e.preventDefault();
          e.stopPropagation();
          if (props.to !== location.pathname) navigate(props.to);
        }}
      />
    </div>
  );
};

ActiveNavLink.displayName = "ActiveNavLink";
